import { Action } from 'redux';

import { ResourceGovernanceResetSiteToDefaults } from '~src/app/actions/AppActionTypes';
import { isActionFactory } from '~src/app/actions/isActionFactory';
import { EntityActionNames, IEntityAction } from '~src/app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { Messages } from '~src/codegen/Localize';

import { IResourceGovernanceSiteSetting } from '../types/ResourceGovernance';

// Everything is set up so we can ask the backend if the action is allowed
// which means that we need to use an "action allowed payload"
export interface IResourceGovernanceResetSiteToDefaultsAction {
  resetSiteResourceGovernanceSite: boolean;
}

// The action itself. Which contains if it's allowed.
export const ResourceGovernanceResetSiteToDefaultsAction: IEntityAction<IResourceGovernanceSiteSetting, IResourceGovernanceResetSiteToDefaultsAction> = {
  name: EntityActionNames.ResourceGovernanceResetSiteToDefaultsAction,
  translateName: Messages.resourceGovernanceResetSiteToDefaultsAction,
  isVisible: () => true,
  isClickable: (availableActions: IResourceGovernanceResetSiteToDefaultsAction) => !!(availableActions && availableActions.resetSiteResourceGovernanceSite),
  createReduxAction: (targetItems: IResourceGovernanceSiteSetting[]) => resetSiteToDefaultsAction(targetItems.map(s => s.siteId)),
};

export interface ResourceGovernanceResetSiteToDefaultsAction extends Action {
  siteIds: string[];
}

export function resetSiteToDefaultsAction(siteIds: string[]): ResourceGovernanceResetSiteToDefaultsAction {
  return {
    type: ResourceGovernanceResetSiteToDefaults,
    siteIds,
  };
}

export const isResetSiteToDefaultsAction = isActionFactory<ResourceGovernanceResetSiteToDefaultsAction>(ResourceGovernanceResetSiteToDefaults);
